import React from 'react'
import './productViewCharte.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { useState } from 'react'
import config from '../../../config'
import axios from 'axios'
import { useEffect } from 'react'
import Select from 'react-select';
import moment from 'moment';
import {
  NdoeImage, optionsCouleursParFamille, NdoePage, NdoePageHeader,
  NdoeFormSection, NdoeActionButton, NdoeResponsiveTable, NdoeDataCard,
  NdoeStatusBadge,
} from '../../../components/ndoe';
import { CloudUploadOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2'
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { useSelector } from 'react-redux'

const ProductView = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [getProduit, setGetProduit] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [getCouleur,setGetCouleur] = useState([]);
    const [getPays,setGetPays] = useState([]);
    const [getTaille,setGetTaille] = useState([]);
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const id = pathname.split('/')[2];
    const [prix, setPrix] = useState([]);
    const [idPays, setIdPays] = useState([]);
    const [variantCheck, setVariantCheck] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const scroll = { x: 400 };
    const [selectedData, setSelectedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [variantExists, setVariantExists] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const userId = useSelector((state) => state.user.currentUser.id)
    
    const handleInputChange = (e) => {
      const fieldName = e.target.name;
      const fieldValue = e.target.value;
    
      let updatedValue = fieldValue;
      let file = null;
      
      if (fieldName === "img") {
        file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagePreview(reader.result);
          };
          reader.readAsDataURL(file);
        } else {
          setImagePreview('');
        }
        updatedValue = file;
      } else if (fieldName === "contact_email") {
        updatedValue = fieldValue.toLowerCase();
      } else if (Number.isNaN(Number(fieldValue))) {
        if (typeof fieldValue === "string" && fieldValue.length > 0) {
          updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
        }
      }
    
      /*
        L'AVERTISSEMENT « CETTE VARIANTE EXISTE DÉJÀ » — REBRANCHÉ SUR LA VRAIE CLÉ.

        Il se déclenchait à la frappe du code variante. Ce champ ayant été retiré
        (le serveur génère le code désormais), la condition ne pouvait plus jamais
        être vraie : l'avertissement serait mort en silence. Supprimer un champ
        ne doit pas emporter le garde-fou qui s'y était accroché.

        ET IL ÉTAIT FAUX. Comparer des codes tapés à la main ne dit rien de
        fiable : deux couleurs d’un même modèle partageaient souvent le même
        code hérité. La vraie clé d’unicité, celle que le serveur applique
        (variant.service.js : id_produit + id_taille + id_couleur), est le
        MODÈLE + LA COULEUR + LA POINTURE.

        On avertit donc à la sélection de la COULEUR : ce modèle a-t-il déjà des
        variantes dans ce coloris ?
      */
      if (fieldName === "id_couleur") {
        /*
          ON COMPARE LE LIBELLE, PAS L IDENTIFIANT — et c est mesure, pas subi.
          /api/catalogue/stock renvoie la couleur par son LIBELLE (« Beige ») et
          non par son id : verifie en appelant le service contre la production,
          les cles rendues ne contiennent pas id_couleur. Ajouter la colonne
          demanderait de traverser trois couches de projection pour un simple
          avertissement — le libelle vient de la meme table couleur, il fait
          le travail.
        */
        const liste = Array.isArray(variantCheck) ? variantCheck : [];
        const libelle = (getCouleur || []).find((c) => String(c.id_couleur) === String(fieldValue))?.description;
        const exists = !!libelle && liste.some((v) => String(v.couleur || '').trim().toLowerCase() === String(libelle).trim().toLowerCase());
        setVariantExists(exists);
      }
      setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
    };

    
      const handleCheckboxChange = (id) => {
        const selectedRecord = getTaille?.find((record) => record.id_taille === id);
        if (selectedIds.includes(id)) {
          setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
          setSelectedData(selectedData.filter((record) => record.id !== id));
        } else {
          setSelectedIds([...selectedIds, id]);
          setSelectedData([...selectedData, selectedRecord]);
        }
      };

      const handleStockChange = (e, id) => {
        const updatedData = selectedData.map((record) => {
          if (record.id_taille === id) {
            return { ...record, stock: e.target.value };
          }
          return record;
        });
        setSelectedData(updatedData);
      };

    useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/produit/${id}`);
            setGetProduit(data[0])

          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN,id]);

      useEffect(()=>{
        setIdPays(data?.id_pays)
        setPrix(getProduit?.prix)
      },[data?.id_pays,getProduit?.prix])

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/couleur`);
            setGetCouleur(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/pays`);
            setGetPays(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            // ⚠ /api/produit/Codevariante ne renvoie QUE `code_variante` de la
            //   table produit — ni id_produit, ni id_couleur. Elle ne pouvait donc
            //   pas servir à savoir « ce modèle a-t-il déjà ce coloris ? ».
            //   On interroge les VARIANTES de CE modèle, qui portent la couleur.
            const { data } = await axios.get(`${DOMAIN}/api/catalogue/stock?id_produit=${id}&limit=1000`);
            setVariantCheck(Array.isArray(data?.variantes) ? data.variantes : []);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/tailleOne/${idPays}`);
            setGetTaille(data)
            setLoading(false)

          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN,idPays]);

      const qTable = [
        {
          title: 'Pointure',
          dataIndex: 'taille',
          width: 110,
          /* Elle était affichée dans un <input disabled>. Un champ désactivé
             reste un champ : il annonce « vous pourriez saisir ici, mais non ».
             Une valeur qu'on LIT est du texte. */
          render: (t) => <span className="pv-pointure num">{t}</span>,
        },
        {
          title: 'Quantité',
          dataIndex: 'stock',
          key: 'stock',
          width: '25%',
          render: (text, record) => {
            const selectedRecord = selectedData.find((selectedRecord) => selectedRecord.id_taille === record.id_taille);
            return (
              <input
                type="number"
                name='stock'
                className='pv-input num'
                onChange={(e) => handleStockChange(e, record.id_taille)}
                disabled = {selectedRecord ? false : true}
                min={0}
              />
            );
          }
        },
        {
          title: 'Sélectionner',
          dataIndex: 'id_taille',
          width: '25%',
          render: (text, record) => {
            const isChecked = selectedIds.includes(record.id_taille);
            return (
              <>
                {isChecked ? (
                  <ToggleOnIcon
                    color="primary"
                    style={{ fontSize: '40px', cursor: 'pointer' }}
                    onClick={() => handleCheckboxChange(record.id_taille)}
                  />
                ) : (
                  <ToggleOffIcon
                    color="disabled"
                    style={{ fontSize: '40px', cursor: 'pointer' }}
                    onClick={() => handleCheckboxChange(record.id_taille)}
                  />
                )}
              </>
            );
          },
        },
      ];

/*       const handleClick = async (e) => {
        e.preventDefault();
      
        if (!data.id_pays || !data.id_couleur || selectedData.length === 0) {
          Swal.fire({
            title: 'Erreur',
            text: 'Veuillez remplir tous les champs requis',
            icon: 'error',
            confirmButtonText: 'OK',
          });
          return;
        }
      
        if (Array.isArray(selectedData) && selectedData.length > 0) {
          try {
            setIsLoading(true);
      
            await Promise.all(
              selectedData.map((item) =>
                axios.post(`${DOMAIN}/api/produit/varianteProduit`, {
                  ...data,
                  id_produit: id,
                  id_cible: item.id_cible,
                  id_taille: item.id_taille,
                  id_famille: item.id_famille,
                  stock: item.stock,
                  prix: prix,
                })
              )
            );
      
            Swal.fire({
              title: 'Succès',
              text: 'Produit créé avec succès !',
              icon: 'success',
              confirmButtonText: 'OK',
            });
      
            navigate('/varianteProduit');
            window.location.reload();
          } catch (err) {
            Swal.fire({
              title: 'Erreur',
              text: err.message,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } finally {
            setIsLoading(false);
          }
        } else {
          console.error('idTaille is not an array');
        }
      }; */

      const handleClick = async (e) => {
        e.preventDefault();
      
        if (!data.id_pays || !data.id_couleur || selectedData.length === 0) {
          Swal.fire({
            title: 'Erreur',
            text: 'Veuillez remplir tous les champs requis',
            icon: 'error',
            confirmButtonText: 'OK',
          });
          return;
        }
      
        if (Array.isArray(selectedData) && selectedData.length > 0) {
          try {
            setIsLoading(true);
      
            const requests = selectedData.map((item) => {
              const formData = new FormData();
              formData.append('id_pays', data.id_pays);
              formData.append('id_couleur', data.id_couleur);
              // Le code variante n'est plus envoyé : le serveur le fabrique.
              formData.append('img', data.img);
              formData.append('id_produit', id);
              formData.append('id_cible', item.id_cible);
              formData.append('id_taille', item.id_taille);
              formData.append('id_famille', item.id_famille);
              formData.append('stock', item.stock);
              formData.append('prix', prix);
              formData.append('userId', userId);
      
              return axios.post(`${DOMAIN}/api/produit/varianteProduit`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            });
      
            await Promise.all(requests);
      
            Swal.fire({
              title: 'Succès',
              text: 'Produit créé avec succès !',
              icon: 'success',
              confirmButtonText: 'OK',
            });
      
            navigate('/varianteProduit');
            window.location.reload();
          } catch (err) {
            Swal.fire({
              title: 'Erreur',
              text: err.message,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } finally {
            setIsLoading(false);
          }
        } else {
          console.error('idTaille is not an array');
        }
      };

      /*
        ⚠ UNE DATE ABSENTE S'AFFICHAIT COMME AUJOURD'HUI.

        `moment(undefined)` ne rend pas une date invalide : il rend L'INSTANT
        PRÉSENT. La fiche d'un modèle sans date d'entrée annonçait donc la date
        du jour, avec l'aplomb d'une vraie donnée — constaté le 22/08/2026 sur un
        produit inexistant, qui affichait « 22-08-2026 ».

        C'est la pire forme d'erreur d'affichage : elle ne ressemble pas à une
        erreur. On rend `null` quand il n'y a rien, et la fiche écrit alors
        « non renseigné ».
      */
      const formattedDatEntrant = getProduit?.date_entree
        ? (moment(getProduit.date_entree).isValid()
          ? moment(getProduit.date_entree).format('DD-MM-YYYY')
          : null)
        : null;

  /*
    UNE FICHE PAR POINTURE SUR TÉLÉPHONE.

    Le tableau portait trois colonnes de SAISIE (quantité, interrupteur). Sur
    375 px elles se compressaient jusqu’à devenir intouchables au pouce. Une
    fiche par pointure rend le même geste possible.
  */
  const renderPointureCard = (record) => {
    const actif = selectedIds.includes(record.id_taille);
    return (
      <NdoeDataCard
        className={`pv-carte ${actif ? 'is-active' : ''}`}
        title={`Pointure ${record.taille}`}
        badge={actif
          ? <NdoeStatusBadge kind="custom" tone="ok" label="Retenue" />
          : <NdoeStatusBadge kind="custom" tone="neutral" label="Non retenue" />}
        actions={(
          <NdoeActionButton
            size="sm" variant={actif ? 'secondary' : 'primary'}
            onClick={() => handleCheckboxChange(record.id_taille)}
          >
            {actif ? 'Retirer' : 'Ajouter cette pointure'}
          </NdoeActionButton>
        )}
      >
        {actif && (
          <div className="pv-carte__qte">
            <label className="pv-label" htmlFor={`pv-qte-${record.id_taille}`}>Quantité reçue</label>
            <input
              id={`pv-qte-${record.id_taille}`}
              type="number"
              min={0}
              className="pv-input num"
              onChange={(e) => handleStockChange(e, record.id_taille)}
            />
          </div>
        )}
      </NdoeDataCard>
    );
  };

  /*
    LA FICHE DU MODÈLE, en libellé / valeur partagé avec le tiroir
    « Information du produit ». Une valeur absente se DIT plutôt que de laisser
    une case vide, qui se lirait comme un défaut d’affichage.
  */
  const Ligne = ({ libelle, valeur, num = false }) => (
    <div className="ndoe-fiche__ligne">
      <span className="ndoe-fiche__libelle">{libelle}</span>
      {valeur === null || valeur === undefined || valeur === '' || valeur === 'Invalid date'
        ? <span className="ndoe-fiche__valeur ndoe-fiche__vide">non renseigné</span>
        : <span className={`ndoe-fiche__valeur${num ? ' num' : ''}`}>{valeur}</span>}
    </div>
  );

  return (
    <NdoePage className="pv-page">
      {/*
        L’EN-TÊTE DIT DE QUEL MODÈLE ON PARLE.

        Il annonçait « Gestion des tailles / Voir les details » — un titre
        générique, la même chose sur les 638 fiches. On ne savait pas, en haut
        de l'écran, quelle paire on était en train de modifier.
      */}
      <NdoePageHeader
        eyebrow="Catalogue"
        title={getProduit?.nom_produit || 'Fiche du modèle'}
        subtitle={[getProduit?.code_produit, getProduit?.nom_categorie]
          .filter(Boolean).join(' · ') || 'Ajouter des pointures et un coloris'}
      />

      <div className="pv-grille">
        <div className="pv-colonne">
          {/*
            ⚠ CE TABLEAU ÉTAIT INVALIDE : des <tr> directement sous <table>,
            sans <tbody>, et des <th scope="row"> pour de simples libellés. Le
            navigateur le rattrapait en silence, mais rien n'alignait les
            colonnes et la charte n'était respectée nulle part.

            Remplacé par le motif de fiche du design system, le même que le
            tiroir « Information du produit » — un seul motif, deux écrans.
          */}
          <div className="ndoe-fiche pv-fiche">
            <Ligne libelle="Nom du modèle" valeur={getProduit?.nom_produit} />
            <Ligne libelle="Référence" valeur={getProduit?.code_produit} num />
            <Ligne libelle="Catégorie" valeur={getProduit?.nom_categorie} />
            <Ligne libelle="Marque" valeur={getProduit?.nom_marque} />
            <Ligne libelle="Matière" valeur={getProduit?.nom_matiere} />
            <Ligne libelle="Famille" valeur={getProduit?.nom_famille} />
            <Ligne libelle="Cible" valeur={getProduit?.nom_cible} />
            <Ligne
              libelle="Prix"
              num
              valeur={getProduit?.prix == null || getProduit?.prix === ''
                ? null
                : `${Number(getProduit.prix).toLocaleString('fr-CD')} $`}
            />
            <Ligne libelle="Entré le" valeur={formattedDatEntrant} num />
          </div>
          <NdoeFormSection
            step={1}
            title="Le coloris et son origine"
            hint="Ces trois informations valent pour toutes les pointures que vous cocherez."
            collapsible={false}
          >
            <div className="pv-champs">
              <div className="pv-champ">
                <label className="pv-label" htmlFor="pv-pays">Pays</label>
                <Select
                  inputId="pv-pays"
                  name="id_pays"
                  placeholder="Sélectionnez un pays…"
                  classNamePrefix="pv-select"
                  options={getPays?.map(item => ({ value: item.id_pays, label: item.code_pays }))}
                  onChange={selectedOption => handleInputChange({ target: { name: 'id_pays', value: selectedOption.value } })}
                />
              </div>
              <div className="pv-champ">
                <label className="pv-label" htmlFor="pv-couleur">Couleur</label>
                <Select
                  inputId="pv-couleur"
                  name="id_couleur"
                  placeholder="Sélectionnez une couleur…"
                  classNamePrefix="pv-select"
                  options={optionsCouleursParFamille(getCouleur)}
                  onChange={selectedOption => handleInputChange({ target: { name: 'id_couleur', value: selectedOption.value } })}
                />
              </div>
              <div className="pv-champ">
                <label className="pv-label" htmlFor="pv-prix">Prix de vente</label>
                <div className="pv-prix">
                  <input
                    id="pv-prix"
                    type="number"
                    name='prix'
                    value={prix}
                    className="pv-input num"
                    min={0}
                    onChange={(e) => setPrix(e.target.value)}
                  />
                  <span className="pv-unite">$</span>
                </div>
              </div>
              <div className="pv-champ pv-champ--large">
                                    {/*
                                      LE CHAMP « CODE VARIANT » A ÉTÉ RETIRÉ (22/08/2026).

                                      La propriétaire : « il m’est demandé de remplir le code
                                      variant, je m’interroge si la page a subi les dernières
                                      modifications ». Réponse : non, sur ce point.

                                      MESURÉ : sur 1 571 variantes vivantes, 1 565 portaient un
                                      code tapé à la main (« PV726 ») et 6 le code généré
                                      (« P659C2 »), ces six créées par le nouveau parcours les
                                      17 et 18 août. Deux conventions coexistaient, et cet
                                      écran laissait en inventer une troisième.

                                      Décision de la propriétaire : on reste sur le code généré.
                                      Le serveur le fabrique — P{id_produit}C{id_couleur} — et
                                      personne ne le saisit plus.
                                    */}
                {variantExists && (
                  <p className="pv-avertissement">
                    <NdoeStatusBadge kind="custom" tone="warn" label="Déjà en rayon" />
                    Ce modèle a déjà des pointures dans ce coloris — les quantités
                    s’ajouteront à celles qui existent.
                  </p>
                )}
              </div>
            </div>

            <div className="pv-actions">
              <NdoeActionButton variant="primary" onClick={handleClick} loading={isLoading} disabled={isLoading}>
                Enregistrer les pointures
              </NdoeActionButton>
            </div>
          </NdoeFormSection>
        </div>
        <div className="pv-colonne">
          <NdoeFormSection step={2} title="La photo du coloris" collapsible={false}>
            <div className="pv-photo">
              {data.img || imagePreview ? (
                <NdoeImage src={imagePreview || data.img} alt="Aperçu du modèle" size={200} />
              ) : (
                <>
                  <input
                    type="file"
                    name="img"
                    style={{ display: 'none' }}
                    id="file-upload"
                    accept=".jpeg, .png, .jpg"
                    onChange={handleInputChange}
                  />
                  {/* Un <button> et non un <div> cliquable : au clavier, un div
                      ne se sélectionne pas et ne s'active pas. */}
                  <button
                    type="button"
                    className="pv-depot"
                    onClick={() => document.getElementById('file-upload').click()}
                  >
                    <CloudUploadOutlined className="pv-depot__icone" />
                    <span>Choisir une photo</span>
                    <small>JPG ou PNG</small>
                  </button>
                </>
              )}
            </div>
          </NdoeFormSection>

          <NdoeFormSection
            step={3}
            title="Les pointures et leurs quantités"
            hint="Activez une pointure pour saisir sa quantité."
            collapsible={false}
          >
            {/*
              ⚠ CE TABLEAU N’AVAIT AUCUNE VUE TÉLÉPHONE. C’était un <Table> antd
              brut : sur 375 px, trois colonnes de saisie se compressaient jusqu’à
              devenir intouchables au pouce. NdoeResponsiveTable rend une fiche par
              pointure en dessous de 768 px — même donnée, geste possible.
            */}
            <NdoeResponsiveTable
              columns={qTable}
              data={getTaille || []}
              rowKey="id_taille"
              loading={loading}
              size="small"
              pagination={false}
              renderCard={renderPointureCard}
              empty={{ icon: '📏', title: 'Aucune pointure', text: 'Choisissez d’abord un pays : les pointures dépendent de son système.' }}
            />
          </NdoeFormSection>
        </div>
      </div>
    </NdoePage>
  )
}

export default ProductView